import { useState } from "react";
import {
    ProductDetailSubTabs,
    ProductDetailTabSection,
    ProductDetailTabTable,
    emptyProductDetailColumns,
    type ProductDetailTabProps
} from "@/views/pages/productManagement/ProductDetailTabPrimitives";

export type indexProps = ProductDetailTabProps;

/** components / feeTab / index：保留数据展示、编辑提交和父级事件回调。 */
export default function MigrationComponent(props: indexProps) {
    const [active, setActive] = useState("收款");
    return (
        <ProductDetailTabSection title="费用明细" className="fee-tab">
            <ProductDetailSubTabs active={active} onChange={setActive} />
            <ProductDetailTabTable
                ariaLabel={`${active}费用明细`}
                columns={emptyProductDetailColumns(
                    active === "收款" ? ["收款编号", "订单编号", "收款金额（元）", "收款时间", "状态"] : ["退款编号", "订单编号", "退款金额（元）", "退款时间", "状态"]
                )}
                data={props.items}
            />
            {props.children}
        </ProductDetailTabSection>
    );
}
